import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { ReferenceDataService } from "../services/referencedata.service";


@Injectable()
export class LanguageResolve implements Resolve<any> {

    constructor(private refService: ReferenceDataService) {

    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        return new Promise<any>((resolve, reject) => {
            this.refService.getLanguages().subscribe(
                (data) => {
                    resolve(data);
                });
        }).then(function (data) {
            return data;
        });

    }

}